var React = require('react');

function Geo5a (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m1090.457 63.641h20c0-22.091-17.909-40-40-40v20c11.046 0 20 8.955 20 20z","fill":"#e1be62","key":0}),React.createElement("path",{"d":"m374.916 157.011v-20c-22.091 0-40 17.909-40 40h20c0-11.046 8.954-20 20-20z","fill":"#97c6bd","key":1}),React.createElement("path",{"d":"m990.88 189.127h40v20h-40z","fill":"#4c372e","transform":"matrix(.7071 .7071 -.7071 .7071 436.8842 -656.4774)","key":2}),React.createElement("path",{"d":"m780.67 135.581c0-11.046 8.954-20 20-20v-20c-22.091 0-40 17.909-40 40s17.909 40 40 40v-20c-11.046 0-20-8.955-20-20z","fill":"#246648","key":3}),React.createElement("path",{"d":"m1189.193 256.359c11.046 0 20 8.954 20 20h20c0-22.091-17.909-40-40-40s-40 17.909-40 40h20c0-11.046 8.954-20 20-20z","fill":"#bb8d75","key":4})]);
}

Geo5a.defaultProps = {"enableBackground":"new 0 0 1280 300","viewBox":"0 0 1280 300"};

module.exports = Geo5a;

Geo5a.default = Geo5a;
